import { Form } from "antd";

import { useSetAccountUsers } from "data/use-accounts";
import { UserSelect } from "components/selects/user-select";
import { useOnChange } from "hooks/use-on-change";
import { Modal } from "components/modal";

export const SetUsers = ({ close, isOpen, account }) => {
  const setAccountUsers = useSetAccountUsers({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setAccountUsers.mutate({
      id: account._id,
      userIds: values.userIds,
    });
  };

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        userIds: account.users,
      });
    },
    [isOpen, form, account]
  );

  return (
    <Modal
      confirmLoading={setAccountUsers.isLoading}
      okText="Set Sales Reps"
      onCancel={close}
      onOk={form.submit}
      title="Sales Reps"
      open={isOpen}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={onFinish}
      >
        <UserSelect
          label="Sales Reps"
          mode="multiple"
          name="userIds"
          placeholder="Select sales reps"
        />
      </Form>
    </Modal>
  );
};
